import { useEffect, useState } from "react";
import { FOCUS_ATTRIBUTE, takeFocus } from "@/lib/portalFocus";

// The item another page asked this one to open (src/lib/portalFocus.js), taken once when
// the page starts: { id, brand }, or null.
export function usePortalFocus(kind, brand = "") {
  const [focus] = useState(() => takeFocus(kind, brand));
  return focus;
}

const MARK = ["ring-2", "ring-amber-400", "ring-offset-2"];
const TRIES = 40;
const EVERY_MS = 150;

// Once `ready` (the list has loaded), scrolls to the element carrying this id and marks it for
// a few seconds. The element may appear a moment later, after a group opens, so it is looked
// for again for a few seconds before giving up quietly.
export function useScrollToFocus(id, ready) {
  useEffect(() => {
    if (!id || !ready) return undefined;
    let tries = 0;
    let timer;
    let unmark;
    const find = () => {
      const selector = `[${FOCUS_ATTRIBUTE}="${CSS.escape(String(id))}"]`;
      const element = document.querySelector(selector);
      if (!element) {
        tries += 1;
        if (tries < TRIES) timer = window.setTimeout(find, EVERY_MS);
        return;
      }
      element.scrollIntoView({ behavior: "smooth", block: "center" });
      element.classList.add(...MARK);
      unmark = window.setTimeout(() => element.classList.remove(...MARK), 4000);
    };
    find();
    return () => {
      window.clearTimeout(timer);
      window.clearTimeout(unmark);
    };
  }, [id, ready]);
}
